import React from 'react';
import TimeRowShell from '../timeRowShell/TimeRowShell';
import BreakCard from '../breakCard/BreakCard';
import * as css from './BreakCardRow.css';
import {TTimetableItem} from '../../../../redux/timetable/timetable.type';

interface BreakCardRowProps {
    time: string;
    breakItem: TTimetableItem;
    onMenuClick: () => void;
}

function BreakCardRow({time, breakItem, onMenuClick}: BreakCardRowProps) {
    return (
        <TimeRowShell time={time}>
            <css.breakArea>
                <BreakCard breakItem={breakItem} onMenuClick={onMenuClick} />
            </css.breakArea>
        </TimeRowShell>
    );
}

export default BreakCardRow;
